<template>
    <div class=" bg-teal-950/40 h-full flex flex-col justify-center items-center ">
    
        <img :src="fileReplyPreview" v-if="fileReply?.type?.includes('image')" alt="a" class="aspect-square w-80">
        <video :src="fileReplyPreview" v-else-if="fileReply?.type?.includes('video')" alt="a" controls
            class="aspect-video w-80"></video>
        <audio :src="fileReplyPreview" v-else-if="fileReply?.type?.includes('audio')" alt="a" controls
            class="aspect-square w-80"></audio>
        <embed :src="fileReplyPreview" width="900" frameBorder="0"
        scrolling="auto" v-else-if="fileReply?.type?.includes('pdf')" alt="a"
            class="aspect-square w-[600px]" />
        <i :src="fileReplyPreview" v-else alt="a" controls class="las la-file text-5xl"></i>
        <div class="font-bold">{{ fileReply?.name }}</div>
        <span class="font-thin">{{ convertFileSize }}</span>
    </div>
</template>
<script>
import { mapFields } from 'vuex-map-fields';

export default {
    name: "SendFile",
    data() {
        return {
            fileReplyPreview: null
        }
    },
    computed: {
        ...mapFields("messages/reply", {
            fileReply: "fileReply",
        }),

        convertFileSize() {
            if (this.fileReply?.size?.length < 7) return `${Math.round((+this.fileReply?.size ?? 0) / 1024).toFixed(2)}kb`
            return `${(Math.round((+this.fileReply?.size ?? 0) / 1024) / 1000).toFixed(2)}MB`
        }
    },
    watch: {
        fileReply(newVal) {
            if(newVal){
                this.fileReplyPreview = URL.createObjectURL(newVal)
            }
        }
    },
    mounted() {
        if (this.fileReply) {
            this.fileReplyPreview = URL.createObjectURL(this.fileReply)
        }
    },
    unmounted(){
        this.fileReplyPreview = null;
        this.fileReply = null
    }

}
</script>